import { useDownloadCsv } from '@fukuri-admins/hooks/common';

type Options = {
  onSuccess?: (blob: Blob) => void;
  onError?: (error: Error) => void;
};

/**
 * 初回ログイン未完了者一覧 CSV ダウンロードフック（任意発火）
 *
 * `GET /api/v1/:threeLetterCode/client_admins/users.csv?f=pending` で CSV を取得し、
 * `trigger()` 呼び出し時に 1 回だけダウンロードする。
 * 一覧と同じ絞り込み（未ログインユーザー + keyword 検索）を反映するため `keyword` を渡す。
 *
 * @param threeLetterCode - クライアントコード
 * @param keyword - 出力対象を絞り込む検索キーワード（未指定の場合は絞り込まない）
 * @param options - 成功時 / 失敗時コールバック
 */
export const useGetClientUsersCsv = (
  threeLetterCode: string,
  keyword?: string,
  options?: Options
) => {
  const searchParams = new URLSearchParams({ f: 'pending' });
  if (keyword) searchParams.set('keyword', keyword);

  return useDownloadCsv(
    `/api/v1/${threeLetterCode}/client_admins/users.csv?${searchParams.toString()}`,
    options
  );
};
